var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGhana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0109C0 17.968 0.352063 19.8427 0.995188 21.5761L16 22.2718L31.0048 21.5761C31.648 19.8428 32 17.968 32 16.0109C32 14.0538 31.648 12.179 31.0048 10.4457L16 9.75L0.995188 10.4456C0.352063 12.179 0 14.0538 0 16.0109H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C9.12055 0.0107422 3.25587 4.35274 0.995178 10.4456H31.0049C28.7441 4.35274 22.8794 0.0107422 16 0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5762H0.995178C3.25587 27.6689 9.12055 32.011 16 32.011C22.8794 32.011 28.7441 27.6689 31.0048 21.5762Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.4453L17.3811 14.6966H21.8516L18.2352 17.3242L19.6164 21.5757L15.9999 18.9482L12.3833 21.5757L13.7648 17.3242L10.1484 14.6966H14.6186L15.9999 10.4453Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGhana);
export default __webpack_public_path__ + "static/media/flag_ghana.f052e5059d206bafdd02b217389111f5.svg";
export { ForwardRef as ReactComponent };